import { DateInput, TextInput, TextLabel } from '@core/components/Inputs';
import { DataBR } from '@format';
import { Grid } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectConta from 'app/components/Select/SelectConta';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import React from 'react';

const TransferenciaForm = ({ bloqueiaDestinoConciliacao = false, bloqueiaOrigemConciliacao = false }) => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;

  const _errors = {
    contaOrigemId: (submitCount > 0 || touched?.contaOrigemId) && errors?.contaOrigemId,
    contaDestinoId: (submitCount > 0 || touched?.contaDestinoId) && errors?.contaDestinoId,
    valor: (submitCount > 0 || touched?.valor) && errors?.valor,
    data: (submitCount > 0 || touched?.data) && errors?.data,
  };

  return (
    <>
      <Grid container spacing={3} className="mt-16  mb-16">
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <SelectConta
            id="contaOrigemId"
            name="contaOrigemId"
            label="Conta origem"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.contaOrigemId || ''}
            touched={!!_errors?.contaOrigemId}
            error={_errors?.contaOrigemId}
            disabled={bloqueiaOrigemConciliacao}
            required
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <SelectConta
            id="contaDestinoId"
            name="contaDestinoId"
            label="Conta destino"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.contaDestinoId || ''}
            touched={!!_errors?.contaDestinoId}
            error={_errors?.contaDestinoId}
            disabled={bloqueiaDestinoConciliacao}
            required
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          {bloqueiaOrigemConciliacao || bloqueiaDestinoConciliacao ? (
            <TextLabel id="lancamento.valor" label="Valor (R$)" value={getCurrencySemSinalMonetario(values?.valor)} />
          ) : (
            <InputMonetario
              fullWidth
              id="valor"
              label="Valor (R$)"
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values?.valor}
              touched={!!_errors.valor}
              error={_errors.valor}
              helperText={_errors.valor}
              disabled={bloqueiaOrigemConciliacao || bloqueiaDestinoConciliacao}
              maximumValue="999999999.99"
              required
            />
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          {bloqueiaOrigemConciliacao || bloqueiaDestinoConciliacao ? (
            <TextLabel id="lancamento.dataPagamento" label="Data" value={DataBR(values?.data)} />
          ) : (
            <DateInput
              fullWidth
              id="data"
              label="Data"
              value={values?.data}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!_errors.data}
              helperText={_errors.data}
              disabled={bloqueiaOrigemConciliacao || bloqueiaDestinoConciliacao}
              required
            />
          )}
        </Grid>

        <Grid item xs={12}>
          <TextInput
            id="descricao"
            name="descricao"
            label="Descrição"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.descricao}
            maxLength={500}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            // disabled={values?.possuiNotaFiscalTransmitida}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TransferenciaForm;
